import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

type BigDropdownIconProps = SvgIconDefaultProps & {
  color?: string;
};
const BigDropdownIcon: React.FC<BigDropdownIconProps> = ({
  color,
  className,
  testId,
  width = 10,
  height = 18,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.text.default;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width={width}
      height={height}
      viewBox="0 0 10 18"
      fill="none"
    >
      <path
        d="M0.668737 9.53674e-07C0.536187 3.21313e-05 0.406661 0.0381989 0.29673 0.109618C0.1868 0.181037 0.101465 0.282461 0.0516439 0.400912C0.00182254 0.519363 -0.0102201 0.649456 0.017058 0.774544C0.0443362 0.899632 0.109694 1.01403 0.204769 1.10309L8.39228 8.9987L0.204769 16.8943C0.140849 16.9535 0.0898174 17.0244 0.0546623 17.1028C0.0195071 17.1813 0.000935224 17.2657 3.442e-05 17.3511C-0.000866384 17.4366 0.0159224 17.5213 0.0494165 17.6004C0.0829107 17.6796 0.132437 17.7514 0.195096 17.8119C0.257755 17.8723 0.332286 17.92 0.414325 17.9523C0.496365 17.9846 0.584262 18.0008 0.672871 18C0.761479 17.9991 0.849017 17.9812 0.930358 17.9473C1.0117 17.9134 1.08521 17.8642 1.14658 17.8025L9.805 9.45281C9.92986 9.33236 10 9.16901 10 8.9987C10 8.82838 9.92986 8.66504 9.805 8.54458L1.14658 0.194861C1.0845 0.133208 1.01022 0.0841941 0.92814 0.0507232C0.846062 0.0172522 0.757853 4.37572e-06 0.668737 9.53674e-07Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default BigDropdownIcon;
